import { t } from "@lingui/macro";
import { Button } from "@reactive-resume/ui";
import { ArrowLeftIcon, LockIcon } from "@phosphor-icons/react";
import { Link, useNavigate } from "react-router";

import { LocaleProvider } from "@/client/providers/locale";

export const FeatureUnavailablePage = () => {
  const navigate = useNavigate();
  return (
    <LocaleProvider>
      <main className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 p-4">
        <div className="w-full max-w-md space-y-8 text-center">
          <div className="space-y-4">
            <div className="mx-auto inline-flex h-24 w-24 items-center justify-center rounded-2xl bg-white/50 shadow-xl backdrop-blur-sm">
              <LockIcon size={48} className="text-gray-500" />
            </div>

            <h1 className="text-2xl font-bold text-gray-900 sm:text-3xl">
              {t`Fonctionnalité non disponible pour le moment.`}
            </h1>

            <p className="text-sm leading-relaxed text-gray-600">
              {t`Cette fonctionnalité sera disponible prochainement. Vous pouvez continuer votre travail ou revenir au tableau de bord.`}
            </p>
          </div>

          <div className="flex flex-col justify-center gap-3 sm:flex-row">
            <Button asChild size="lg" className="min-w-[180px]" onClick={() => navigate(-1)}>
              <div>
                <ArrowLeftIcon size={18} className="mr-2" />
                {t`Retour`}
              </div>
            </Button>
            <Button asChild variant="outline" size="lg" className="min-w-[180px]">
              <Link to="/client/user-space">{t`Tableau de bord`}</Link>
            </Button>
          </div>
        </div>
      </main>
    </LocaleProvider>
  );
};
